import React from 'react';
import LoginAction from 'actions/LoginAction';
import IntlObject from '../Common/IntlObject';

function LogoutModal() {
  const handleLogout = () => {
    LoginAction.logout();
    window.location.reload();
  };

  return (
    <div
      className="modal fade"
      id="logoutModal"
      role="dialog"
      aria-labelledby="logoutModalLabel"
    >
      <div className="modal-dialog modal-login">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="logoutModalLabel">
              <IntlObject keycode="topbar.logout" returnType="span" />
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body" style={{ fontSize: '1.1em' }}>
            <IntlObject keycode="modal.logout.confirm" returnType="span" />
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              <IntlObject keycode="modal.logout.cancel" returnType="span" />
            </button>
            <button
              type="button"
              className="btn btn-primary"
              data-bs-dismiss="modal"
              onClick={handleLogout}
            >
              <IntlObject keycode="topbar.logout" returnType="span" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LogoutModal;
